import type * as React from 'react'

import { clsx } from 'clsx'

import { PostCardView } from '~publish/components/PostCardView'

import styles from './ContentItemDetailsCard.module.css'

import type { JSX } from 'react'

export type ContentItemDetailsCardViewProps = {
  header?: React.ReactNode
  content: React.ReactNode
  media?: React.ReactNode
  author: React.ReactNode
  actions: React.ReactNode
  className?: string
}

export function ContentItemDetailsCardView({
  header,
  content,
  media,
  author,
  actions,
  className,
}: ContentItemDetailsCardViewProps): JSX.Element {
  return (
    <PostCardView
      className={clsx(styles.card, className)}
      header={header}
      content={content}
      media={media}
      footer={
        <footer className={styles.footer}>
          {author}
          <div className={styles.actions}>{actions}</div>
        </footer>
      }
    />
  )
}
